import {
  typography_external_styles_default
} from "./chunk.TCJMBLWH.js";
import {
  typography_styles_default
} from "./chunk.6YWIBUQR.js";
import {
  typographyTypeTagNameMap
} from "./chunk.TSLPWEGG.js";
import {
  i,
  l,
  n as n2
} from "./chunk.47PJ6NWT.js";
import {
  applyExternalStyles
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/typography/typography.ts
var FadvTypography = class extends s {
  constructor() {
    super(...arguments);
    this.type = "paragraph-medium";
    this.variant = "default";
    this.scale = 600;
  }
  connectedCallback() {
    super.connectedCallback();
    applyExternalStyles(this, typography_external_styles_default);
  }
  render() {
    const tag = l`${i(typographyTypeTagNameMap[this.type])}`;
    return n2`<${tag} part="base" class=${o({
      typography: true,
      [`typography--${this.type}`]: true,
      [`typography--weight-${this.weight}`]: !!this.weight,
      [`typography--${this.variant}-${this.scale}`]: this.variant !== "default"
    })} ><slot></slot></${tag}>`;
  }
};
FadvTypography.styles = typography_styles_default;
__decorateClass([
  e({ reflect: true })
], FadvTypography.prototype, "type", 2);
__decorateClass([
  e({ reflect: true })
], FadvTypography.prototype, "variant", 2);
__decorateClass([
  e({ type: Number })
], FadvTypography.prototype, "weight", 2);
__decorateClass([
  e({ reflect: true, type: Number })
], FadvTypography.prototype, "scale", 2);
FadvTypography = __decorateClass([
  n("fadv-typography")
], FadvTypography);

export {
  FadvTypography
};
